import React, { memo, useMemo, useRef } from 'react';
import cx from 'classnames';
import { useState, useEffect } from 'react';
import {
  apiGetAllNotifications,
  apiMarkAllAsReadNotifications,
  apiDeleteAllNotifications,
  apiMarkAsReadNotification,
} from '../../helpers/api';
import _ from 'lodash';
import { useScreenSettings } from '../../helpers/configureHelper';
import styles from './NotificationsPanel.module.scss';
import { getCommonMetadata } from '../../helpers/jsHelper';
import { errorToast, successToast, warningToast } from '../../helpers/toastHelper';
import NotificationsPanelCard from './NotificationsPanelCard';
import { icons } from '../../assets';
import { checkIfEmailIsVerifiedOrNot, useUserContext } from '../../contexts/UserContext';
import { SKELETON_LOADER_TYPE } from '../../skeletonLoaderUI/SkeletonLoaderUI';
import InfiniteScroll from '../../components/InfiniteScroll/InfiniteScroll';
import { Mixpanel, MxEvent } from '../Mixpanel';
import CustomTab from '../Tab';
import {
  NOTIFICATION_MENU_TAB,
  NOTIFICATION_MODEL_TYPE,
  ORG_JOIN_REQUEST_STATUS,
} from '../../constants/constants';
import { CheckMarkIcon, CloseIcon, FilterIcon2, SettingsIcon } from '../../assets/icons';
import MenuDropdown from '../MenuDropdown';
import { useNavigate } from 'react-router-dom';
import { ADMIN_SETTINGS } from '../../constants/routePathConstants';
import {
  AcceptOrDeniedOrgRequest,
  JoinOrgRequest,
  ManageOrgsChooseModel,
} from '../../screens/NewRegisterOnboard/Index';
const { GreenTickIcon, TrashV2Icon } = icons;

const NotificationsPanel = memo(({ notificationToggle = null, show = null, notificationCount, setRefreshOrgList = ()=> {} }) => {
  const navigate = useNavigate();
  const { currentUser } = useUserContext();
  const [notifications, setNotifications] = useState([]);
  const [unreadFlag, setUnreadFlag] = useState(false);
  const [mutedFlag, setMutedFlag] = useState(false);
  const [markAllAsRead, setMarkAllAsRead] = useState(false);
  const [clearAll, setClearAll] = useState(false);
  const [filterField, setFilterField] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState('');
  const [refresh, setRefresh] = useState(false);
  const [total, setTotal] = useState(0);
  const [acceptOrDeniedJoinOrgRequest, setAcceptOrDeniedJoinOrgRequest] = useState([]);
  const [orgRequestList, setOrgRequestList] = useState({
    deniedRequestList: [],
    acceptedRequestList: [],
    pendingRequestList: [],
  });

  const isMountedRef = useRef(true);
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(()=> {
    if(notificationCount > 0){
      setRefresh(!refresh)
    }
  },[notificationCount])

  useEffect(() => {
    if (notifications?.length) {
      const unreadAndJoinRequest = notifications?.filter(
        ({ unread, target_object_id, type }) =>
          unread && target_object_id && type === NOTIFICATION_MODEL_TYPE.JoinOrgRequest
      );
      setAcceptOrDeniedJoinOrgRequest(unreadAndJoinRequest || []);
      clearAll && setClearAll(false)
    }
  }, [notifications]);

  useEffect(() => {
    if (acceptOrDeniedJoinOrgRequest?.length) {
      setOrgRequestList({
        acceptedRequestList: acceptOrDeniedJoinOrgRequest.filter(
          ({ data }) => data?.join_request_data?.status === ORG_JOIN_REQUEST_STATUS.APPROVED
        ),
        pendingRequestList: acceptOrDeniedJoinOrgRequest.filter(
          ({ data }) => data?.join_request_data?.status === ORG_JOIN_REQUEST_STATUS.NEW
        ),
        deniedRequestList: acceptOrDeniedJoinOrgRequest.filter(
          ({ data }) => data?.join_request_data?.status === ORG_JOIN_REQUEST_STATUS.DENIED
        ),
      });
    } else {
      setOrgRequestList({
        acceptedRequestList: [],
        pendingRequestList: [],
        deniedRequestList: [],
      });
    }
  }, [acceptOrDeniedJoinOrgRequest]);
  // const [notificationTitle, setNotificationTitle] = useState('All');

  const tabList = [
    {
      eventKey: NOTIFICATION_MENU_TAB.ALL.eventKey,
      title: NOTIFICATION_MENU_TAB.ALL.title,
      component: '',
    },
    {
      eventKey: NOTIFICATION_MENU_TAB.UNREAD.eventKey,
      title: NOTIFICATION_MENU_TAB.UNREAD.title,
      component: '',
    },
    {
      eventKey: NOTIFICATION_MENU_TAB.MUTE.eventKey,
      title: NOTIFICATION_MENU_TAB.MUTE.title,
      component: '',
    },
  ];

  const cardType = 'notifications';
  const pageSettings = useScreenSettings(cardType);
  const { sortOptions, filterOptions, defaultSortOption } = pageSettings;

  const [sortField, setSortField] = useState(defaultSortOption);
  const [isPermissionModal, setIsPermissionModal] = useState(false);


  const { hasData } = getCommonMetadata(notifications, pageNumber, totalPages);

  const hasMore = pageNumber < totalPages;

  async function loadNotifications(param = null) {
    setLoading(true);
    const res = await apiGetAllNotifications(param);
    if (!isMountedRef.current) return;
    if (res?.total_pages) {
      setTotalPages(res.total_pages);
    }
    if (res?.count) {
      setTotal(res.count);
    }
    if (
      notifications?.length === 0 ||
      (notifications?.length !== 0 && pageNumber === 1) ||
      pageNumber === 1
    ) {
      setNotifications(res?.results);
    } else {
      setNotifications([...notifications, ...res?.results]);
    }
    // if (param === null) setNotificationTitle('All');
    setLoading(false);
  }

  useEffect(() => {
    let q = '';

    if (sortField) {
      if (q !== '') q = `${q}&`;
      q += `ordering=${sortField?.value}`;
    }
    q += `&timestamp_val=${new Date()?.getTime()}`
    if (unreadFlag) {
      if (q !== '') q = `${q}&`;
      q += `unread=${unreadFlag}`;
    }
    if (mutedFlag) {
      if (q !== '') q = `${q}&`;
      q += `is_muted=${mutedFlag}`;
    }
    if (filterField) {
      if (q !== '') q = `${q}&`;
      q += `type=${filterField?.value}`;
    }

    if (q !== '') {
      q = pageNumber === 1 ? `?${q}&page=1` : `?${q}&page=${pageNumber}`;
    } else {
      q = pageNumber === 1 ? `?page=1` : `?page=${pageNumber}`;
    }

    setQuery(q);
  }, [sortField, filterField, unreadFlag, mutedFlag, pageNumber, refresh]);

  function fetchMoreData() {
    if (pageNumber < totalPages) {
      setPageNumber((prev) => Number(prev) + 1);
    }
  }
  function handleFilter(e) {
    handleMxEvent('filter applied ' + e.label);
    setPageNumber(1);
    setFilterField(e);
  }
  function handleSort(e) {
    handleMxEvent('sort applied ' + e.label);
    setPageNumber(1);
    setSortField(e);
  }

  const shouldLoadNotifications = useMemo(() => query, [query, currentUser, refresh]);

  useEffect(() => {
    if (shouldLoadNotifications) loadNotifications(query);
  }, [shouldLoadNotifications]);

  useEffect(() => {
    if (unreadFlag) {
      // setNotificationTitle('Unread');
    } else if (mutedFlag) {
      // setNotificationTitle('Muted');
    } else {
      setUnreadFlag(false);
      setMutedFlag(false);
      // setNotificationTitle('All');
    }
  }, [unreadFlag, mutedFlag]);

  const markAsRead = async (id) => {
    handleMxEvent('Notification read');
    const res = await apiMarkAsReadNotification(id);
    if (res && res.status) {
      const updatedNotifications = notifications?.map((a) => {
        if (a?.id === id) {
          return res?.data;
        } else return a;
      });
      setNotifications(updatedNotifications);
    }
  };

  const markAllRead = async () => {
    setLoading(true);
    if (!markAllAsRead) {
      const res = await apiMarkAllAsReadNotifications();
      if (res && res.status) {
        successToast(res?.message);
        setMarkAllAsRead(res.status);
      } else {
        errorToast(res?.message);
      }
      loadNotifications(query);
    } else {
      warningToast('No unread notifications.');
      loadNotifications(query);
    }
  };
  const clearAllNotifications = async () => {
    setLoading(true);
    if (!clearAll) {
      const res = await apiDeleteAllNotifications();
      if (res && res.status) {
        successToast(res?.message);
        setClearAll(res.status);
      } else {
        errorToast(res?.message);
      }
      loadNotifications(query);
    } else {
      warningToast('No notifications to clear.');
      setLoading(false);
    }
    setUnreadFlag(false);
    setMutedFlag(false);
    setMarkAllAsRead(false);
  };

  const handleMxEvent = (action_type) => {
    Mixpanel.track(true, MxEvent.NOTIFICATION_ACTION, {
      action_type: action_type,
    });
  };

  const handleActiveTab = (val) => {
    setPageNumber(1);
    if (NOTIFICATION_MENU_TAB.MUTE.eventKey === val) {
      handleMxEvent('Show muted');
      setUnreadFlag(false);
      setMutedFlag(!mutedFlag);
    } else if (NOTIFICATION_MENU_TAB.ALL.eventKey === val) {
      handleMxEvent('Show All');
      setMutedFlag(false);
      setUnreadFlag(false);
    } else {
      handleMxEvent('Show unread only');
      setMutedFlag(false);
      setUnreadFlag(true);
    }
  };

  const handleRedirectToSetting = () => {
    navigate(`${ADMIN_SETTINGS}?activeTab=notifications`);
    notificationToggle && notificationToggle?.();
  };

  const ActionMenu = filterOptions?.map((opt) => {
    return {
      label: opt?.label,
      value: opt?.value,
      icon: filterField?.value === opt?.value ? <CheckMarkIcon color="#2B2A28" /> : null,
      afterIcon: filterField?.value === opt?.value ? true : false,
      onClick: handleFilter,
    };
  });

  const handleSelect = (method) => {
    method?.onClick &&
      method?.onClick({
        label: method?.label,
        value: method?.value,
      });
  };

  const handleReadNotification = (data) => {
    if(notifications?.length){
      if (!data?.id) return;
      markAsRead(data?.id);
    }else{
      setAcceptOrDeniedJoinOrgRequest([])
    }
  };

  if (orgRequestList?.acceptedRequestList?.length && !show) {
    return (
      <ManageOrgsChooseModel
        readNotification={() => {
          handleReadNotification(orgRequestList?.acceptedRequestList?.[0]);
          setRefreshOrgList?.(orgRequestList?.acceptedRequestList?.[0])
        }}
        body={
          <AcceptOrDeniedOrgRequest
            data={orgRequestList?.acceptedRequestList?.[0]}
            isSuccess={true}
            readNotification={(data) => {
              handleReadNotification(data || orgRequestList?.acceptedRequestList?.[0]);
              setRefreshOrgList?.(data || orgRequestList?.acceptedRequestList?.[0])
            }}
            applyBg
          />
        }
      />
    );
  }

  if (orgRequestList?.deniedRequestList?.length && !show) {
    return (
      <ManageOrgsChooseModel
        readNotification={() => handleReadNotification(orgRequestList?.deniedRequestList?.[0])}
        body={
          <AcceptOrDeniedOrgRequest
            data={orgRequestList?.deniedRequestList?.[0]}
            isSuccess={false}
            readNotification={handleReadNotification}
            applyBg
          />
        }
      />
    );
  }

  if (orgRequestList?.pendingRequestList?.length && !show) {
    return (
      <ManageOrgsChooseModel
        readNotification={() => handleReadNotification(orgRequestList?.pendingRequestList?.[0])}
        dialogClassName={isPermissionModal ? 'givePermissionContainer' : ""} 
        size={"xl"}
        body={
          <JoinOrgRequest
            data={orgRequestList?.pendingRequestList?.[0]}
            readNotification={handleReadNotification}
            applyBg
            setIsPermissionModal={setIsPermissionModal}
          />
        }
      />
    );
  }

  if (!show) {
    return null;
  }
  return (
    <span>
      <div
        className={styles.notificationOverlay}
        onClick={() => notificationToggle && notificationToggle?.()}></div>
      <aside id="notificationWrapper" className={cx(styles.notificationWrapper)}>
        <div className={cx(styles.notifcationHeader)}>
          <div className={cx(styles.notificationHeaderInner)}>
            <h5 className={styles.title}>Notifications</h5>
          </div>
          <div className={cx(styles.notificationHeaderAction)}>
            <MenuDropdown
              btnClassName="py-0 pe-0"
              icon={<FilterIcon2 width={18} height={18} title="Filter By" />}
              menu={ActionMenu}
              handleSelect={handleSelect}
            />
            <SettingsIcon
              title="Notification Setting"
              width={20}
              height={20}
              onClick={handleRedirectToSetting}
            />
            {notifications.length > 0 &&
              notifications?.filter((a) => a.verb !== '')?.length > 0 && (
                <TrashV2Icon
                  width={20}
                  height={20}
                  title="Clear all notifications"
                  onClick={(e) => {
                    handleMxEvent('Clear all notifications');
                    clearAllNotifications();
                  }}
                />
              )}
            <CloseIcon title="Close" width={14} height={14} onClick={notificationToggle} />
          </div>
        </div>
        <div className={cx(styles.notificationTab)}>
          <CustomTab
            tabList={tabList}
            stopScroll={true}
            defaultActive={NOTIFICATION_MENU_TAB.ALL.eventKey}
            className={cx(styles.notificationTabWrap)}
            handleActiveTab={handleActiveTab}
            stopReset={true}
          />
          {notifications.length > 0 &&
            notifications?.filter((a) => a.verb !== '' && a?.unread)?.length > 0 && (
              <span
                className={styles.marksAsRead}
                onClick={(e) => {
                  handleMxEvent('Mark all as read');
                  markAllRead();
                }}>
                Mark all as read
              </span>
            )}
        </div>
        <div
          id="infiniteScroll"
          className={styles.notificationsContainer}
          style={
            !checkIfEmailIsVerifiedOrNot(false)
              ? {
                  paddingBottom: '3.75rem',
                }
              : {}
          }>
          <InfiniteScroll
            dataLength={notifications.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loadingType={SKELETON_LOADER_TYPE.NOTIFICATION}
            loading={loading}
            hasChildren={hasData}
            scrollableTarget="infiniteScroll">
            {notifications
              ?.filter((a) => a.verb !== '')
              ?.map((a) => (
                <NotificationsPanelCard
                  key={a.id}
                  data={a}
                  onClick={markAsRead}
                  loadNotifications={loadNotifications}
                  refresh={refresh}
                  setRefresh={setRefresh}
                />
              ))}
            {!loading && !notifications.length && (
              <h6 className="ps-4 ms-3">No Notifications Found!!!</h6>
            )}
          </InfiniteScroll>
        </div>
      </aside>
    </span>
  );
});

export default NotificationsPanel;
